import React, { useEffect, useRef } from "react"

import gsap from "gsap"
import styled from "styled-components"
import media from "styles/media"
import colors from "styles/colors"
import text from "styles/text"
import StyledLink from "./StyledLink"
import { ReactComponent as QuoteSquare } from "images/orange-square-quote.svg"
import SplitText from "gsap/SplitText"
import ContentWidth from "./ContentWidth"

gsap.registerPlugin(SplitText)

const AnimatedQuote = ({ content }) => {
  const allQuotes = content.quotes.map((quote, index) => (
    <QuoteContent className="quotes" id={`quote-${index}`}>
      <Quote className="text">{quote.quote}</Quote>
      <Person className="text">{quote.person}</Person>
    </QuoteContent>
  ))

  useEffect(() => {
    const quotes = gsap.utils.toArray(".quotes")
    const text = document.querySelector(".text")

    const splitTextDiv = new SplitText(".text", {
      types: "lines",
      linesClass: "lineDivs",
    })

    const tl = gsap.timeline({ repeat: -1 })

    tl.from(".quotes", {
      opacity: 0,
      duration: 1,
      stagger: 4,
      "--varHeight": "100%",
    }).to(".quotes", { opacity: 0, stagger: 4 }, 4)
  }, [])

  return (
    <ContentWidth>
      <Wrapper>
        <QuoteOuterContainer>
          <QuoteImg />
          {allQuotes}
        </QuoteOuterContainer>
        <HeadlineDiv>
          <Headline>{content.headline}</Headline>
          <StyledLink href={content.linkUrl}>{content.linkText}</StyledLink>
        </HeadlineDiv>
      </Wrapper>
    </ContentWidth>
  )
}

const QuoteImg = styled(QuoteSquare)`
  position: absolute;
  top: -3vw;
  left: 2vw;
  width: 4.167vw;
  height: 4.167vw;

  ${media.fullWidth} {
    top: -43px;
    left: 29px;
    width: 60px;
    height: 60px;
  }

  ${media.tablet} {
    top: -4.3vw;
    left: 2.832vw;
    width: 5.859vw;
    height: 5.859vw;
  }

  ${media.mobile} {
    top: -10.776vw;
    left: 6.776vw;
    width: 12.019vw;
    height: 12.019vw;
  }
`
const Person = styled.p`
  ${text.bodyMd};
  position: relative;
  overflow: hidden;

  ${media.mobile} {
    ${text.bodySm};
  }
`
const Quote = styled.p`
  ${text.bodyXL};
  width: 26.667vw;
  position: relative;
  overflow: hidden;

  ${media.fullWidth} {
    width: 384px;
  }

  ${media.tablet} {
    width: 32.813vw;
  }

  ${media.mobile} {
    width: 72.897vw;
    ${text.bodyLg};
  }
`
const QuoteContent = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  height: auto;
  gap: 1.667vw;
  width: 26.667vw;

  .lineDivs {
    :root {
      --varHeight: 0%;
    }

    :before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: var(--varHeight);
      background-color: ${colors.grey25};
    }
  }

  ${media.fullWidth} {
    gap: 24px;
    width: 384px;
  }

  ${media.tablet} {
    gap: 2.344vw;
    width: 32.813vw;
  }

  ${media.mobile} {
    gap: 5.607vw;
    width: 72.897vw;
  }
`
const QuoteOuterContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${colors.grey25};
  height: 18.681vw;
  border-radius: 1.667vw;
  width: 31.111vw;
  padding: 2.778vw 2.222vw;

  ${media.fullWidth} {
    height: 269px;
    width: 448px;
    border-radius: 24px;
    padding: 40px 32px;
  }

  ${media.tablet} {
    height: 26.27vw;
    width: 39.063vw;
    border-radius: 2.344vw;
    padding: 3.906vw 3.125vw;
  }

  ${media.mobile} {
    height: 41.121vw;
    width: 87.85vw;
    border-radius: 5.607vw;
    padding: 9.346vw 7.477vw;
  }
`
const Headline = styled.h3`
  ${text.h3};
  width: 39.167vw;

  ${media.fullWidth} {
    width: 564px;
  }

  ${media.tablet} {
    width: 45.313vw;
  }

  ${media.mobile} {
    width: 87.85vw;
  }
`
const HeadlineDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1.667vw;

  ${media.fullWidth} {
    gap: 24px;
  }

  ${media.tablet} {
    gap: 2.344vw;
  }

  ${media.mobile} {
    gap: 8.411vw;
  }
`
const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 9.167vw;
  padding: 0vw 10.278vw;
  width: 100%;

  ${media.fullWidth} {
    gap: 132px;
    padding: 0 148px;
  }

  ${media.tablet} {
    gap: 7.813vw;
    padding: 0 3.906vw;
  }

  ${media.mobile} {
    flex-direction: column;
    gap: 14.019vw;
    padding: 14.019vw 6.075vw;
  }
`
export default AnimatedQuote
